import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarEtiqueta } from "../../../services/atualizarEtiquetaService";

export const useAtualizarEtiqueta = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);

  const atualizar = async (id: number | undefined, data: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    const dataNovo = {
      id,
      ...data,
    };

    try {
      const atualizarCamp = await atualizarEtiqueta(dataNovo);

      if (atualizarCamp) {
        setSuccess(true);
        setIsSuccess(true); // Adicionando para refletir o sucesso
      } else {
        setError(true);
      }
    } catch (error) {
      console.error(error);
      setError(true); // Adicionando para capturar erro corretamente
    } finally {
      setIsLoading(false);
    }
  };

  return { atualizar, isLoading, isSuccess, error, success, resetError };
};
